import React from 'react';
import { useTheme } from '../App';
import { Logo } from '../components/Logo';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 36 }}>
    <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--cyan)', marginBottom: 12, fontFamily: 'Orbitron', letterSpacing: 1 }}>
      {title}
    </h2>
    <div style={{ color: 'var(--text)', lineHeight: 1.75, fontSize: 14 }}>
      {children}
    </div>
  </div>
);

const Sub = ({ title, children }) => (
  <div style={{ marginBottom: 20 }}>
    <h3 style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 8, marginTop: 16 }}>{title}</h3>
    {children}
  </div>
);

export default function Nutzungsbedingungen() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '40px 20px 80px' }}>
      <button
        onClick={toggleTheme}
        style={{ position: 'fixed', top: 20, right: 20, zIndex: 10, background: 'var(--glass)', border: '1px solid var(--glass-border2)', borderRadius: 20, padding: '6px 14px', fontSize: 12, fontFamily: 'Outfit', color: 'var(--text2)', cursor: 'pointer', backdropFilter: 'blur(12px)' }}
      >
        {theme === 'dark' ? '☀ Hell' : '◑ Dunkel'}
      </button>

      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <Logo size={36} />
          <h1 style={{ fontFamily: 'Orbitron', fontSize: 22, fontWeight: 700, color: 'var(--text)', marginTop: 20, marginBottom: 8 }}>
            Nutzungsbedingungen
          </h1>
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>
            KI-Content-Tool · app.look4more.de · Stand: Juni 2026
          </p>
        </div>

        <div className="glass-card" style={{ padding: '32px 36px', borderRadius: 20 }}>

          <Section title="1. Geltungsbereich und Vertragsgegenstand">
            <p>
              Diese Nutzungsbedingungen regeln den Zugang und die Nutzung des KI-Content-Tools (nachfolgend "Tool"
              oder "Dienst"), das unter <strong style={{ color: 'var(--text)' }}>app.look4more.de</strong> erreichbar
              ist und von look4more (Steffen Woik, Neustrelitz) betrieben wird.
            </p>
            <div style={{ margin: '16px 0', padding: '16px 20px', background: 'var(--glass)', borderRadius: 12, border: '1px solid var(--glass-border)', lineHeight: 2 }}>
              <strong style={{ color: 'var(--text)' }}>look4more</strong><br />
              Steffen Woik<br />
              Neustrelitz<br />
              Deutschland<br />
              E-Mail: <a href="mailto:kontakt@look4more.de" style={{ color: 'var(--cyan)' }}>kontakt@look4more.de</a>
            </div>
            <p>
              Mit der Registrierung und Nutzung des Dienstes akzeptierst du diese Nutzungsbedingungen in ihrer
              jeweils gültigen Fassung. Sie gelten für alle registrierten Nutzer (Unternehmen sowie
              Einzelpersonen im gewerblichen Kontext).
            </p>
            <p style={{ marginTop: 8 }}>
              Das Tool ist ein Software-as-a-Service-Angebot (SaaS) zur KI-gestützten Erstellung und
              Veröffentlichung von Social-Media-Inhalten. Es richtet sich ausschließlich an gewerbliche
              Nutzer. Eine Nutzung durch Verbraucher im Sinne des § 13 BGB ist nicht vorgesehen.
            </p>
          </Section>

          <Section title="2. Zugang und Nutzung der Anwendung">
            <Sub title="2.1 Zugangsvoraussetzung">
              <p>
                Der Zugang zum Tool setzt eine Registrierung mit einer gültigen E-Mail-Adresse und einem
                persönlichen Einladungscode (Invite-Code) voraus. Einladungscodes werden von look4more
                vergeben und sind nicht übertragbar.
              </p>
            </Sub>

            <Sub title="2.2 Account">
              <p>
                Jeder Nutzer darf nur einen Account anlegen. Die Zugangsdaten sind vertraulich zu behandeln
                und dürfen nicht an Dritte weitergegeben werden. Bei Verlust oder unbefugter Nutzung ist
                look4more unverzüglich zu informieren.
              </p>
            </Sub>

            <Sub title="2.3 Verfügbarkeit">
              <p>
                look4more bemüht sich um eine hohe Verfügbarkeit des Tools, übernimmt jedoch keine Garantie
                für eine ununterbrochene Erreichbarkeit. Wartungsarbeiten, Updates und vorübergehende
                Ausfälle begründen keinen Anspruch auf Schadensersatz oder Minderung.
              </p>
            </Sub>

            <Sub title="2.4 Kontingente und Tier-System">
              <p>
                Die Nutzung des Tools unterliegt je nach Zugangsstufe (Tier) festgelegten monatlichen
                Kontingenten für Post-Generierungen, Veröffentlichungen und KI-Bildgenerierungen.
                Das aktuelle Kontingent ist im Dashboard einsehbar. Ein Übertrag nicht genutzter
                Kontingente in den Folgemonat findet nicht statt.
              </p>
            </Sub>
          </Section>

          <Section title="3. Pflichten des Nutzers">
            <Sub title="3.1 Erlaubte Nutzung">
              <p>
                Der Dienst darf ausschließlich für rechtmäßige Zwecke genutzt werden. Insbesondere ist es
                untersagt:
              </p>
              <ul style={{ paddingLeft: 20, marginTop: 8, color: 'var(--text2)' }}>
                <li>Inhalte zu generieren oder zu veröffentlichen, die gegen geltendes Recht verstoßen (z.B. Urheberrecht, Wettbewerbsrecht, Persönlichkeitsrechte)</li>
                <li>Irreführende, diffamierende, hasserfüllte oder diskriminierende Inhalte zu erstellen</li>
                <li>Das Tool automatisiert oder in einer Weise zu nutzen, die den Betrieb unverhältnismäßig belastet</li>
                <li>Zugangsdaten Dritter zu verwenden oder Sicherheitsmechanismen zu umgehen</li>
                <li>Den Dienst oder Teile davon zu kopieren, zu vermieten oder weiter zu lizenzieren</li>
              </ul>
            </Sub>

            <Sub title="3.2 Verantwortung für generierte Inhalte">
              <p>
                Du bist als Nutzer allein verantwortlich für die Inhalte, die du mit dem Tool generierst
                und veröffentlichst. Dazu gehört insbesondere:
              </p>
              <ul style={{ paddingLeft: 20, marginTop: 8, color: 'var(--text2)' }}>
                <li>Prüfung auf rechtliche Zulässigkeit (Urheberrecht, Wettbewerbsrecht, Presserecht)</li>
                <li>Kennzeichnung von Werbeinhalten gemäß § 5a UWG und den Plattformrichtlinien</li>
                <li>Kennzeichnung KI-generierter Inhalte, sofern plattform- oder rechtlich vorgeschrieben</li>
                <li>Einhaltung der Nutzungsbedingungen der jeweiligen Social-Media-Plattformen</li>
              </ul>
              <p style={{ marginTop: 8 }}>
                look4more übernimmt keine Haftung für Inhalte, die über den Dienst erstellt oder
                veröffentlicht werden.
              </p>
            </Sub>

            <Sub title="3.3 Richtigkeit von Eingaben">
              <p>
                Angaben im Firmenprofil, im Voice Profile und in Prompts müssen wahrheitsgemäß und frei
                von personenbezogenen Daten Dritter ohne deren Einwilligung sein. Die Qualität der
                generierten Inhalte hängt direkt von der Vollständigkeit und Richtigkeit dieser Angaben ab.
              </p>
            </Sub>
          </Section>

          <Section title="4. Google Analytics Integration">
            <Sub title="4.1 Optionale Verbindung">
              <p>
                Das Tool bietet die Möglichkeit, dein Google Analytics 4 (GA4) Konto über den
                OAuth-2.0-Standard zu verbinden. Diese Integration ist vollständig optional und kann
                jederzeit in den Einstellungen getrennt werden.
              </p>
            </Sub>

            <Sub title="4.2 Umfang des Zugriffs">
              <p>
                Bei der Verbindung erteilst du dem Tool ausschließlich <strong style={{ color: 'var(--text)' }}>lesenden Zugriff</strong> auf
                deine GA4 Property. Es werden keine Daten in deinem Google Analytics Konto
                verändert, gelöscht oder neu erstellt. Der Zugriff beschränkt sich auf:
              </p>
              <ul style={{ paddingLeft: 20, marginTop: 8, color: 'var(--text2)' }}>
                <li>Seitenaufrufe, Sitzungen und Nutzeranzahl</li>
                <li>Traffic-Quellen und Gerätekategorien</li>
                <li>Ausgewählte Konversionsdaten deiner Property</li>
              </ul>
            </Sub>

            <Sub title="4.3 Datenspeicherung und Nutzung">
              <p>
                Das OAuth-Token für den GA4-Zugriff wird verschlüsselt in unserer Datenbank gespeichert
                und ausschließlich für die Darstellung deiner Analytics-Daten im Dashboard sowie
                für den monatlichen Leistungsbericht verwendet. Eine Weitergabe an Dritte findet
                nicht statt.
              </p>
            </Sub>

            <Sub title="4.4 Widerruf">
              <p>
                Du kannst die GA4-Verbindung jederzeit unter <strong style={{ color: 'var(--text)' }}>Einstellungen → Kanäle</strong> trennen.
                Mit dem Trennen der Verbindung wird der gespeicherte Token sofort und unwiderruflich gelöscht.
                Zusätzlich kannst du den Zugriff direkt in deinem Google-Konto unter
                Sicherheit → Drittanbieter-Apps widerrufen.
              </p>
            </Sub>

            <Sub title="4.5 Verantwortung gegenüber Google">
              <p>
                Durch die Verbindung stimmst du den Nutzungsbedingungen der Google API Services zu.
                Du stellst sicher, dass du berechtigt bist, die verknüpfte GA4 Property zu verwalten.
                look4more handelt dabei als von dir autorisierter Verarbeiter deiner Analytics-Daten.
              </p>
            </Sub>
          </Section>

          <Section title="5. Haftungsausschluss">
            <Sub title="5.1 Haftung für KI-generierte Inhalte">
              <p>
                Die durch das Tool generierten Texte und Bilder basieren auf KI-Modellen (Anthropic Claude,
                Google Gemini). look4more übernimmt keine Gewähr für die inhaltliche Richtigkeit,
                Vollständigkeit, Aktualität oder Originalität der generierten Inhalte. KI-Systeme können
                fehlerhafte, veraltete oder irreführende Ausgaben produzieren. Die Prüfung und
                Freigabe liegt ausschließlich beim Nutzer.
              </p>
            </Sub>

            <Sub title="5.2 Haftungsbeschränkung">
              <p>
                Die Haftung von look4more ist auf Vorsatz und grobe Fahrlässigkeit beschränkt. Bei einfacher
                Fahrlässigkeit haftet look4more nur für die Verletzung wesentlicher Vertragspflichten
                (Kardinalpflichten) und nur in Höhe des vorhersehbaren, vertragstypischen Schadens.
                Eine weitergehende Haftung — insbesondere für entgangenen Gewinn, mittelbare Schäden oder
                Schäden aus der Nutzung veröffentlichter KI-Inhalte — ist ausgeschlossen.
              </p>
            </Sub>

            <Sub title="5.3 Drittanbieter">
              <p>
                Der Dienst nutzt externe APIs (Anthropic, Google, Upload-Post, Resend). look4more hat keinen
                Einfluss auf die Verfügbarkeit dieser Drittdienste und haftet nicht für Ausfälle, Fehler
                oder Datenverluste, die durch diese Dienste verursacht werden.
              </p>
            </Sub>

            <Sub title="5.4 Plattformsperren">
              <p>
                look4more übernimmt keine Haftung für Sperrungen, Einschränkungen oder andere Maßnahmen,
                die Social-Media-Plattformen (Instagram, Facebook, LinkedIn u.a.) infolge der über den
                Dienst veröffentlichten Inhalte gegen den Nutzer verhängen.
              </p>
            </Sub>
          </Section>

          <Section title="6. Änderungen der Nutzungsbedingungen">
            <p>
              look4more behält sich vor, diese Nutzungsbedingungen bei wesentlichen Änderungen des Dienstes
              oder der Rechtslage anzupassen. Änderungen werden dir mindestens 14 Tage vor Inkrafttreten
              per E-Mail an deine registrierte Adresse mitgeteilt.
            </p>
            <p style={{ marginTop: 8 }}>
              Widersprichst du den geänderten Nutzungsbedingungen nicht innerhalb von 14 Tagen nach
              Zugang der Mitteilung, gelten die neuen Bedingungen als akzeptiert. Auf dieses Recht und
              die Folge des Schweigens wird in der Mitteilung ausdrücklich hingewiesen.
            </p>
            <p style={{ marginTop: 8 }}>
              Im Fall des Widerspruchs endet das Nutzungsverhältnis mit Ablauf der 14-Tage-Frist.
              Bereits generierte Inhalte können weiterhin lokal genutzt werden.
            </p>
          </Section>

          <Section title="7. Anwendbares Recht und Gerichtsstand">
            <p>
              Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des
              UN-Kaufrechts (CISG).
            </p>
            <p style={{ marginTop: 8 }}>
              Da der Dienst sich ausschließlich an gewerbliche Nutzer richtet, ist Gerichtsstand für
              alle Streitigkeiten aus oder im Zusammenhang mit diesen Nutzungsbedingungen der Sitz
              von look4more in Neustrelitz.
            </p>
            <p style={{ marginTop: 8 }}>
              Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder werden,
              bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Die unwirksame Bestimmung
              wird durch eine wirksame ersetzt, die dem wirtschaftlichen Zweck der unwirksamen
              Regelung am nächsten kommt.
            </p>
          </Section>

          <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid var(--glass-border)', textAlign: 'center' }}>
            <p style={{ fontSize: 12, color: 'var(--text2)' }}>
              Hinweis: Dieses Dokument wurde sorgfältig erstellt, ersetzt jedoch keine individuelle Rechtsberatung.
              Vor dem Produktivbetrieb empfehlen wir eine Prüfung durch einen auf IT-Recht spezialisierten Anwalt.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginTop: 20, flexWrap: 'wrap' }}>
              <a href="/login" style={{ color: 'var(--cyan)', fontSize: 13, textDecoration: 'none' }}>
                ← Zurück zum Login
              </a>
              <a href="/datenschutz" style={{ color: 'var(--text2)', fontSize: 13, textDecoration: 'none' }}>
                Datenschutzerklärung →
              </a>
              <a href="https://look4more.de/impressum" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text2)', fontSize: 13, textDecoration: 'none' }}>
                Impressum →
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
